import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { APIURL, APIURLCOT } from "../../../Config";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Pagination from "../../Pagination/Pagination";
import { Modal } from "react-bootstrap";
import MapContainer from "./MapContainer";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import SearchDetails from "../../SearchDetails";
import Epf from "./Epf";

function CreditAppraisalForMagic() {
  const emailid = localStorage.getItem("emailId");
  const [activeTab, setActiveTab] = useState("tab1");
  const [imgUrl, setImgUrl] = useState({});

  const [tvrPending, setTvrPending] = useState([]);
  const [tvrRejected, setTvrRejected] = useState([]);
  const [neftSuccessData, setNeftSuccessData] = useState([]);
  const [showModalImg, setShowModalImg] = useState(false);

  const [instantDisburse, setInstantDisburse] = useState([]);
  const [neftRejectedData, setNeftRejectedData] = useState([]);
  const [pdData, setpdData] = useState({});

  const [reHitPennyDrop, setReHitPennyDrop] = useState([]);
  const [data, setData] = useState([]);
  const [eqfexdata, setEqfexData] = useState({});
  const [schemeData, setSchemeData] = useState([]);

  const [isLoader, setIsLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const token = localStorage.getItem("token");

  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [password, setPassword] = useState("");
  const [clientPhotoBase64, setClientPhotoBase64] = useState(null);
  const [approve, setApprove] = useState("");
  const [mapValue, setMapValue] = useState("");
  const [mapStatus, setMapStatus] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [hide, setHide] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [lid, setLid] = useState("");
  const [appClientId, setAppClientId] = useState("");

  const TVRPending = React.useRef(null);
  const NEFTData = React.useRef(null);
  const InstantDisbursed = React.useRef(null);
  const NEFTRejected = React.useRef(null);
  const TVRRejected = React.useRef(null);
  const ReHitDrop = React.useRef(null);
  const fileInputRef = useRef(null);
  const [alert, setAlert] = useState(null);
  const [changeloanid, setChangeloanid] = useState("");
  const [progress, setProgress] = useState(false);
  const [showLoanUpdate, setShowLoanUpdate] = useState(false);
  const [allDoc, setAllDoc] = useState([]);

  const [type, setType] = useState("S");
  const [appid, setAppid] = useState("");
  const [loanData, setLoanData] = useState([]);

  const [loanUpdateDetails, setLoanUpdateDetails] = useState({
    appClientId: appClientId,
    loanAmount: schemeData?.loanAmount || "",
    interestRate: schemeData?.irr || "",
    installment: schemeData?.installments || "",
  });
  const formRef = useRef();
  const [selectedOption, setSelectedOption] = useState("0"); // '0' is default for "All"

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const [showTable, setShowTable] = useState(false);

  const [selectedLoan, setSelectedLoan] = useState(null);
  const [loanCalculationData, setLoanCalculationData] = useState({});

  // Handler for loan selection
  const handleLoanSelection = (loanAmount, tenure) => {
    setSelectedLoan({ loanAmount, ...tenure });

    // Calculate loan details (replace with your actual calculation logic)
    const calculatedData = {
      "Loan Amount": loanAmount,
      "Tenure (Months)": tenure.tenureMonths,
      "Monthly EMI": tenure.monthlyEmi,
      "Interest Rate": "12%", // Example value
      "Total Interest": "XYZ", // Calculate this
      "Total Payment": "XYZ", // Calculate this
    };

    setLoanCalculationData(calculatedData);
  };

  const handleReset = () => {
    // Your reset logic here
  };

  function getAllDoc(appId) {
    setIsLoader(true);

    axios
      .request(`${APIURL}/allUploadedDocs/${appId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAllDoc(response?.data);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  const handleOpenLoanUpdate = () => {
    setLoanUpdateDetails({
      appClientId: appClientId,
      loanAmount: "",
      interestRate: "",
      installment: "",
    });
    setShowTable(false);
    setShowLoanUpdate(true);
  };

  const handleLoanUpdate = (loanAmount, interestRate, installment) => {
    setProgress(true);
    axios(
      `${APIURL}/schemecheck/${loanAmount}/${interestRate}/${installment}/${
        data.appClientId ? data.appClientId : data.appclientid
      }`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.data.error) {
          setShowTable(false);
          alert(response.data.error);
        } else {
          setLoanCalculationData(response.data);
          setShowTable(true);
        }
        setProgress(false);
      })
      .catch((error) => {
        console.log("Error during API call:", error);
        setShowTable(false);
        setProgress(false);
      });
  };
  // const handelCheckLoanid = () => {
  //   setProgress(true);
  //   axios(
  //     `https://ctlmiweb.capitaltrust.in:8080/credit/api/creditAppraisal/schemecheck?loanId=${changeloanid}`,
  //     {
  //       method: "GET",
  //       credentials: "include",
  //     }
  //   )
  //     .then((response) => {
  //       if (response.data.status == 1) {
  //         setAppid(response.data.appid);
  //         handleOpenLoanUpdate();
  //       } else {
  //         alert("Not applicable for scheme change");
  //       }
  //       setProgress(false);
  //     })
  //     .catch((error) => {
  //       console.log("Error during API call:", error);
  //       setShowTable(false);
  //       setProgress(false);
  //     });
  // };

  const handleCloseLoanUpdate = () => {
    setShowLoanUpdate(false);
    setSelectedLoan(null);
  };

  const handleInputChangenew = (event) => {
    const { name, value } = event.target;

    if (Number(value) < 0) {
      alert("Value cannot be negative!");
      return;
    }

    setLoanUpdateDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    const { loanAmount, interestRate, installment } = {
      ...loanUpdateDetails,
      [name]: value,
    };

    if (!loanAmount || !interestRate || !installment) {
      setShowTable(false);
    }
  };

  const handleApproveLoanUpdate = () => {
    console.log("selectedLoan::: ", selectedLoan);
    setProgress(true);
    const loanApproveDetails = {
      appClientId: data.appClientId ? data.appClientId : data.appclientid,
      loanAmount: loanCalculationData.loanAmount,
      interestRate: loanCalculationData?.irr,
      installment: loanCalculationData?.installments,
      approvedBy: emailid,
      // schemestatus: selectedOption,
    };
    console.log("loanApproveDetails::: ", loanApproveDetails);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://tap.salarytap.in:8083/salarytap/schemes/approve",
      headers: {
        "Content-Type": "application/json",
        Cookie: "JSESSIONID=09C1B4435E582E375FF44E85D5EEB5D4",
      },
      data: loanApproveDetails,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("response::: ", response);

        toast.success("Approved successfully!!");
        handleCloseLoanUpdate();
        handleCloseLoanUpdate();
        setProgress(false);
      })
      .catch((error) => {
        console.log("Error during API call:", error);
        setProgress(false);
      });
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    if (activeTab === "tab1") {
      getTvrPendingDetails();
    }
    if (activeTab === "tab3") {
      getAllNeftSuccessData();
    }
    if (activeTab === "tab2") {
      getInstantDisburse();
    }
    if (activeTab === "tab4") {
      getAllNeftRejectedData();
    }
    if (activeTab === "tab5") {
      getAllRejectedCases();
    }
    if (activeTab === "tab6") {
      getReHitPennyDrop();
    }
  }, [activeTab]);

  function getTvrPendingDetails() {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getTvrPendingDetails/CTLPER`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTvrPending(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getEquifaxCCRDetailsData(appIds, schemeId) {
    setIsLoader(true);
    axios
      .request(`${APIURL}/EquifaxCCRDetails/${appIds}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setEqfexData(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getSchemeList(phone) {
    setIsLoader(true);
    axios
      .request(`${APIURL}/extendlmtPL/${phone}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setLoanData(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function getSchemeData(appIds, schemeId) {
    setIsLoader(true);
    axios
      .request(`${APIURL}/schemecheck/${appIds}/${schemeId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setSchemeData(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getAllNeftSuccessData() {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getAllNeftSuccessData`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setNeftSuccessData(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getInstantDisburse() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getInstantDisburseApprovedCases`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setInstantDisburse(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function getAllNeftRejectedData() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getAllNeftRejectedData`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setNeftRejectedData(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getAllRejectedCases() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getAllRejectedCases/CTLPER`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        setTvrRejected(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getReHitPennyDrop() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getReHitPennyDrop`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);

        if (typeof response?.data !== "string") {
          setReHitPennyDrop(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getClientDetailsMagic(loanId) {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getClientDetailsMagic/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response?.data);
        getEquifaxCCRDetailsData(response?.data.appClientId);
        getAllDoc(response?.data.appClientId);

        getSchemeData(response?.data.appClientId, response?.data.schemeNo);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function allUploadedDocs() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/allUploadedDocs/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function AccountAggregator() {
    window.open(`${APIURL}/download/${loanId}`);
  }
  function groLocation() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/clientdetails/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowModal(true);
        setIsLoader(false);

        console.log("response", response);
        setMapValue(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function companyLocation() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getGeoLocation/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })

      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }

  function epfDetails() {
    setIsLoader(true);

    axios
      .request(`${APIURL}/epfdetails/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  const handleModalClose = () => {
    setShowModal(false);
  };

  const excludedKeysMap = {
    0: [
      "netDisbAmountWithoutBoth",
      "netDisbAmountWithoutHospi",
      "netDisbAmountwithoutInsurance",
    ],
    1: [
      "netDisbAmountwithoutInsurance",
      "netDisbAmount",
      "netDisbAmountWithoutBoth",
    ],
    2: [
      "netDisbAmount",
      "netDisbAmountWithoutBoth",
      "netDisbAmountWithoutHospi",
    ],
    3: [
      "netDisbAmount",
      "netDisbAmountWithoutBoth",
      "netDisbAmountwithoutInsurance",
    ],
  };

  const excludedKeys = excludedKeysMap[selectedOption] || [];

  const handleDetailsChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (loadEvent) => {
        const base64String = loadEvent.target.result;
        setClientPhotoBase64(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const employerUploadContact = () => {
    setIsLoader(true);

    const dto = {
      mobileNo: data.mobile,
      appclientid: data.appClientId ? data.appClientId : data.appclientid,
      latitude: "28.6679571",
      longitude: "77.2302148",
      clientPhotoBase64: clientPhotoBase64,
      clientUID: data?.enrollmentid,
      ownerEmail: emailid,
    };
    console.log("data", dto);
    axios
      .request(`${APIURL}/employerUploadContact`, {
        method: "POST",
        data: dto,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setShowUploadModal(false);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = () => {
    if (approvalStatus == 2) {
      if (password == "ctlA") {
        setShowPasswordModal(false);
        setShowApproveModal(true);
      } else {
        toast.warning("Wrong password");
      }
    }
    if (approvalStatus == 3) {
      if (password == "ctlR") {
        submitData();
        setShowPasswordModal(false);
      } else {
        toast.warning("Wrong password");
      }
    }
  };

  const handleApprove = (status) => {
    if (status == "new") {
      console.log("status", status);
      setApprove("new");
      submitData(status);
      setPassword("");
      setRemark("");
    }
    if (status == "ignore") {
      pop(status);
      setPassword("");
      setRemark("");
    }
  };

  const submitData = (status) => {
    console.log("approve", approve);
    const appId = localStorage.getItem("userId");
    const dto = {
      actionType: status,
      appclientid: data.appClientId ? data.appClientId : data.appclientid,
      creditstatus: approvalStatus,
      borrname: data.clientName,
      borrcontactno: data.mobile,
      borrremark: remark,
      approvedby: appId,
    };
    const formData = new FormData();

    for (const key in dto) {
      if (dto.hasOwnProperty(key)) {
        formData.append(key, dto[key]);
      }
    }
    console.log("dto", dto);
    axios
      .request(`${APIURL}/salarytap/saveca`, {
        method: "POST",
        data: formData,
        headers: {
          Authentication: token,

          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        handleTabClick("tab1");
        setShowApproveModal(false);
        toast.success(response?.data?.remark);
        if (response?.data?.remark) {
          setHide(true);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const pop = (status) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title="Are you sure?"
        onConfirm={() => {
          setApprove(status);
          submitData(status);
          setShowApproveModal(false);
          setAlert(null);
        }}
        onCancel={() => {
          setAlert(null);
          setShowApproveModal(false);
        }}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="secondary"
        confirmBtnText="Are you confirm?"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };
  const instantDisburseApprove = (appCientId) => {
    const data = {
      appClientId: appCientId,
      approvedby: 16,
      ownerEmail: emailid,
    };
    setIsLoader(true);

    axios
      .request(`${APIURL}/approvedAndReject`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("Approve successfully.");
        getInstantDisburse();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const instantDisburseReject = (appCientId) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/BorrowerDetail/CTLPER`, {
        method: "GET",
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("Rejected successfully");
        getInstantDisburse();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const reHitPennyDropApprove = (id) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getReHitPennyDropApproved/${id}`, {
        method: "GET",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("ReHitPennyDrop approve successfully");
        getReHitPennyDrop();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const reHitPennyDropReject = (id) => {
    setIsLoader(true);

    axios
      .request(`${APIURL}/rejectPennyDrop/${id}`, {
        method: "GET",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        toast.success("ReHitPennyDrop rejected successfully");
        getReHitPennyDrop();
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className="p-3">
      <div>
        <div>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab1" ? "active" : ""
                }`}
                id="tab1-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab1"
                type="button"
                role="tab"
                aria-controls="tab1"
                aria-selected={activeTab === "tab1"}
                onClick={() => handleTabClick("tab1")}
              >
                TVR Pending
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab2" ? "active" : ""
                }`}
                id="tab2-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab2"
                type="button"
                role="tab"
                aria-controls="tab2"
                aria-selected={activeTab === "tab2"}
                onClick={() => handleTabClick("tab2")}
              >
                TVR Approve
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab3" ? "active" : ""
                }`}
                id="tab3-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab3"
                type="button"
                role="tab"
                aria-controls="tab3"
                aria-selected={activeTab === "tab3"}
                onClick={() => handleTabClick("tab3")}
              >
                NEFT Success Data
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab4" ? "active" : ""
                }`}
                id="tab4-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab4"
                type="button"
                role="tab"
                aria-controls="tab4"
                aria-selected={activeTab === "tab4"}
                onClick={() => handleTabClick("tab4")}
              >
                NEFT Rejected Data
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab5" ? "active" : ""
                }`}
                id="tab5-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab5"
                type="button"
                role="tab"
                aria-controls="tab5"
                aria-selected={activeTab === "tab5"}
                onClick={() => handleTabClick("tab5")}
              >
                TVR Rejected
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link tab-item ${
                  activeTab === "tab6" ? "active" : ""
                }`}
                id="tab6-tab"
                data-bs-toggle="tab"
                data-bs-target="#tab6"
                type="button"
                role="tab"
                aria-controls="tab6"
                aria-selected={activeTab === "tab6"}
                onClick={() => handleTabClick("tab6")}
              >
                ReHit Penny Drop
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className={`tab-pane fade ${
                activeTab === "tab1" ? "show active" : ""
              }`}
              id="tab1"
              role="tabpanel"
              aria-labelledby="tab1-tab"
            >
              <div className="pt-3">
                {!show ? (
                  <div className="card">
                    <div className="p-3">
                      {showSearch ? (
                        <>
                          <div className="p-3 d-flex justify-content-start mt-3">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => {
                                setShowSearch(false);
                              }}
                            >
                              Back
                            </button>
                          </div>
                          <div className="p-3 pt-2">
                            <SearchDetails
                              keyName="appClientId"
                              searchInput={appClientId}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <div className="d-flex ">
                            <DownloadTableExcel
                              filename="TVRPending"
                              sheet="users"
                              currentTableRef={TVRPending.current}
                            >
                              <button
                                className="btn btn-success border"
                                style={{
                                  width: "120px",
                                  backgroundColor: "#66a725",
                                }}
                              >
                                {" "}
                                Download{" "}
                              </button>
                            </DownloadTableExcel>
                          </div>
                          {isLoader ? (
                            <div className="d-flex justify-content-center">
                              <div
                                className="spinner-border text-success"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <div className="table-responsive mt-3">
                              <table className="table table-striped">
                                <thead>
                                  <tr>
                                    <th className="text-nowrap text-center">
                                      Sr. No
                                    </th>
                                    <th className="text-nowrap text-center">
                                      App Client Id
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Client Name
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Mobile No
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Loan Type
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Scheme No.
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Sanction Amount
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Verification Date
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Branch Name
                                    </th>
                                    <th className="text-nowrap text-center">
                                      Cluster
                                    </th>
                                    <th className="text-nowrap text-center">
                                      PD Entry Date
                                    </th>
                                    <th className="text-nowrap text-center">
                                      CA Status
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tvrPending
                                    ?.slice(pagination.start, pagination.end)
                                    ?.map((item, i) => (
                                      <tr key={i}>
                                        <td>{i + 1 + pagination.start}</td>
                                        <td
                                          className="text-nowrap text-center text-primary"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (item.appClientId) {
                                              setAppClientId(item.appClientId);
                                              setShowSearch(true);
                                            }
                                          }}
                                        >
                                          {item.appClientId}
                                        </td>
                                        <td className="text-nowrap">
                                          {item.clientName}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.clientmobileno}
                                        </td>
                                        <td className="text-nowrap">
                                          {item.loanType}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.schemeNo}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.sanctionAmount}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.verificationDate}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.branchname || "-"}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.cluster || "-"}
                                        </td>
                                        <td className="text-nowrap text-center">
                                          {item.pdEntryDate || "-"}
                                        </td>
                                        <td>
                                          <button
                                            className="btn btn-success"
                                            onClick={() => {
                                              setShow(true);
                                              setLoanId(item?.appClientId);
                                              getClientDetailsMagic(
                                                item?.appClientId
                                              );
                                              getSchemeList(
                                                item?.clientmobileno
                                              );
                                            }}
                                          >
                                            View
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {tvrPending && tvrPending.length !== 0 && (
                            <Pagination
                              showPrePage={showPrePage}
                              onPaginationChange={onPaginationChange}
                              total={tvrPending.length}
                            />
                          )}
                        </>
                      )}

                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={TVRPending}
                      >
                        <thead>
                          <tr>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sr. No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              App Client Id
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Client Name
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Mobile No
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Loan Type
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Scheme No.
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Sanction Amount
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              Verification Date
                            </th>
                            <th
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              CA Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tvrPending?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>

                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.appClientId}
                              </td>
                              <td className="text-nowrap">{item.clientName}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.clientmobileno}
                              </td>
                              <td className="text-nowrap">{item.loanType}</td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.schemeNo}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.sanctionAmount}
                              </td>
                              <td
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                {item.verificationDate}
                              </td>
                              <td></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <>
                    {alert}
                    <div className="card">
                      <div className="p-3">
                        <div className="d-flex justify-content-end">
                          <div>
                            <button
                              className="btn btn-success"
                              onClick={() => setShow(false)}
                              style={{
                                width: "100px",
                                color: "#66a725",
                                background: "transparent",
                                border: "0px",
                                textDecoration: "underline",
                                fontSize: "18px",
                              }}
                            >
                              Back
                            </button>
                          </div>
                        </div>

                        <div className="">
                          <ul
                            className="nav nav-tabs-CT"
                            id="myTab"
                            role="tablist"
                          >
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/allUploadedDocs/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  ID Photo
                                </a>
                              </button>
                            </li> */}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  Self Photo
                                </a>
                              </button>
                            </li> */}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/epfdetails/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  EPF DETAILS
                                </a>
                              </button>
                            </li> */}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  PAN CARD
                                </a>
                              </button>
                            </li> */}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                              >
                                <a
                                  href={`${APIURL}/download/${loanId}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  ACCOUNT AGGREGATOR
                                </a>
                              </button> 
                            </li>*/}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link nav-itm-CT tab-link-ct `}
                                role="tab"
                              >
                                <a href="#" style={{ textDecoration: "none" }}>
                                  DEVICE DETAILS
                                </a>
                              </button>
                            </li> */}
                            {/* <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link tab-link `}
                                role="tab"
                                onClick={companyLocation}
                                style={{ textDecoration: "none" }}
                              >
                                COMPANY LOCATION
                              </button>
                            </li> */}

                            {allDoc?.map((list, key) => (
                              <li
                                className="nav-item"
                                role="presentation"
                                key={key}
                              >
                                <div
                                  className="card ml-2 mt-2 shadow-sm d-flex flex-column justify-content-between"
                                  style={{
                                    width: "160px",
                                    height: "200px",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <img
                                    className="card-img-top p-2"
                                    src={list.doclink}
                                    alt="Document Preview"
                                    style={{
                                      height: "150px",
                                      width: "100%",
                                      objectFit: "contain",
                                      borderTopLeftRadius: "8px",
                                      borderTopRightRadius: "8px",
                                      backgroundColor: "#f8f9fa",
                                    }}
                                  />
                                  <div className="card-body p-2 text-center d-flex align-items-end">
                                    <button
                                      className="btn  btn-sm w-100"
                                      role="tab"
                                      onClick={() =>
                                        // window.open(list.doclink, "_blank")
                                        {
                                          setShowModalImg(true);
                                          setImgUrl(list);
                                        }
                                      }
                                      style={{
                                        textDecoration: "none",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        color: "blue",
                                      }}
                                    >
                                      {list.doctype
                                        .replace(/_/g, " ")
                                        .toUpperCase()}
                                    </button>
                                  </div>
                                </div>
                              </li>
                            ))}

                            {/* <li className="nav-item mt-3 ml-2" role="presentation">
                        <div class="card">
                          <button
                            className={`nav-link nav-itm-CT tab-link-ct `}
                            role="tab"
                            style={{ textDecoration: "none" }}
                            onClick={groLocation}
                          >
                            GEOLOCATION
                          </button>
                        </div>
                      </li> */}

                            {/* {pdDoc.map((list, key) => (
                              <li className="nav-item" role="presentation">
                                <button
                                  className={`nav-link nav-itm-CT tab-link-ct `}
                                  role="tab"
                                  style={{ textDecoration: "none" }}
                                  onClick={() =>
                                    window.open(list.url, "_blank")
                                  }
                                >
                                  {list.doctype}
                                </button>
                              </li>
                            ))} */}
                          </ul>
                        </div>

                        <Modal
                          show={showModalImg}
                          onHide={() => setShowModalImg(false)}
                          style={{ background: "rgb(255 255 255 / 40%)" }}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title> {imgUrl?.doctype}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {/* Staff ID Input */}
                            <img
                              className="card-img-top p-2"
                              src={imgUrl?.doclink}
                              alt="Document Preview"
                              style={{
                                height: "500px",
                                width: "100%",
                                objectFit: "contain",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px",
                                backgroundColor: "#f8f9fa",
                              }}
                            />

                            {/* Loan Amount Inputs */}

                            <div className="d-flex mt-3 justify-content-end">
                              <button
                                className="btn btn-secondary"
                                style={{ width: "100px" }}
                                onClick={() => setShowModalImg(false)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-primary ml-2"
                                style={{ width: "100px" }}
                                onClick={() =>
                                  window.open(imgUrl?.doclink, "_blank")
                                }
                              >
                                Download
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>

                        <Modal
                          size="lg"
                          show={showModal}
                          onHide={handleModalClose}
                          style={{ background: "#ffffffc4" }}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>GEOLOCATION</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <MapContainer data={mapValue} status={mapStatus} />
                          </Modal.Body>
                        </Modal>
                        {/* <Modal
                          show={showLoanUpdate}
                          onHide={handleCloseLoanUpdate}
                          size="lg"
                          centered
                        >
                          <Modal.Header closeButton className="border-0 pb-0">
                            <Modal.Title className="fw-bold">
                              Select Loan Amount
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="pt-0">
                            {!selectedLoan && (
                              <div className="loan-options">
                                {loanData.map((loanOption) => (
                                  <div
                                    key={loanOption.loanAmount}
                                    className="mb-4"
                                  >
                                    <div className="fs-5 fw-bold mb-2">
                                      {loanOption.loanAmount.toLocaleString()}
                                    </div>
                                    <div className="d-flex flex-wrap gap-3">
                                      {loanOption.tenureMonths.map((tenure) => (
                                        <div
                                          key={`${loanOption.loanAmount}-${tenure.tenureMonths}`}
                                          className="flex-grow-1"
                                        >
                                          <input
                                            type="radio"
                                            className="btn-check"
                                            name="loanOption"
                                            id={`loan-${loanOption.loanAmount}-${tenure.tenureMonths}`}
                                            onChange={() =>
                                              handleLoanSelection(
                                                loanOption.loanAmount,
                                                tenure
                                              )
                                            }
                                          />
                                          <label
                                            className="btn btn-outline-primary w-100 text-start px-3 py-2"
                                            htmlFor={`loan-${loanOption.loanAmount}-${tenure.tenureMonths}`}
                                          >
                                            <div className="d-flex justify-content-between align-items-center">
                                              <span>
                                                {tenure.tenureMonths} Months
                                              </span>
                                              <span className="text-muted">
                                                (
                                                {tenure.monthlyEmi.toLocaleString()}
                                                )
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {selectedLoan && (
                              <div className="mt-4">
                                <h5 className="mb-3">Loan Summary</h5>
                                <div className="table-responsive">
                                  <table className="table table-striped table-bordered">
                                    <thead className="table-light">
                                      <tr>
                                        <th>Field</th>
                                        <th>Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.entries(selectedLoan)
                                        .filter(
                                          ([key]) => !excludedKeys.includes(key)
                                        )
                                        .map(([key, value]) => (
                                          <tr key={key}>
                                            <td className="fw-semibold">
                                              {key}
                                            </td>
                                            <td>
                                              {typeof value === "number"
                                                ? value.toLocaleString()
                                                : value}
                                            </td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="bg-light p-3 rounded mb-3">
                                  <div className="d-flex flex-wrap gap-3">
                                    {[
                                      { value: "0", label: "All" },
                                      {
                                        value: "1",
                                        label: "Without Inc and Hosp",
                                      },
                                      { value: "2", label: "Without Inc" },
                                      { value: "3", label: "Without Hosp" },
                                    ].map((option) => (
                                      <div
                                        key={option.value}
                                        className="form-check"
                                      >
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="disbursementOption"
                                          id={`option-${option.value}`}
                                          value={option.value}
                                          checked={
                                            selectedOption === option.value
                                          }
                                          onChange={handleOptionChange}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`option-${option.value}`}
                                        >
                                          {option.label}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Modal.Body>
                          <Modal.Footer className="border-0">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={handleCloseLoanUpdate}
                            >
                              Cancel
                            </button>
                            {selectedLoan && (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleApproveLoanUpdate}
                              >
                                Approve
                              </button>
                            )}
                          </Modal.Footer>
                        </Modal> */}
                        <Modal
                          show={showLoanUpdate}
                          onHide={handleCloseLoanUpdate}
                          size="lg"
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Update Loan Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <form ref={formRef} onReset={handleReset}>
                              <div className="mb-3">
                                <label
                                  htmlFor="loanAmount"
                                  className="form-label"
                                >
                                  Loan Amount
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="loanAmount"
                                  name="loanAmount"
                                  value={loanUpdateDetails.loanAmount}
                                  onChange={handleInputChangenew}
                                />
                              </div>

                              <div className="mb-3">
                                <label
                                  htmlFor="interestRate"
                                  className="form-label"
                                >
                                  Interest Rate
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="interestRate"
                                  name="interestRate"
                                  value={loanUpdateDetails.interestRate}
                                  onChange={handleInputChangenew}
                                />
                              </div>

                              <div className="mb-3">
                                <label
                                  htmlFor="installment"
                                  className="form-label"
                                >
                                  No. of Installments
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="installment"
                                  name="installment"
                                  value={loanUpdateDetails.installment}
                                  onChange={handleInputChangenew}
                                />
                              </div>

                              {showTable && (
                                <div className="mt-4">
                                  <h5>Loan Summary</h5>
                                  <table className="table table-striped table-bordered">
                                    <thead>
                                      <tr>
                                        <th>Field</th>
                                        <th>Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.entries(loanCalculationData)
                                        .filter(
                                          ([key]) => !excludedKeys.includes(key)
                                        )
                                        .map(([key, value]) => (
                                          <tr key={key}>
                                            <td>{key}</td>
                                            <td>{value}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                  {/* <div
                                    style={{
                                      padding: "16px",
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                      display: "flex",
                                      gap: "32px", // More space between options
                                      alignItems: "center",
                                      flexWrap: "wrap", // Allows wrapping on smaller screens
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {[
                                      { value: "0", label: "All" },
                                      {
                                        value: "1",
                                        label: "Without Inc and Hosp",
                                      },
                                      { value: "2", label: "Without Inc" },
                                      { value: "3", label: "Without Hosp" },
                                    ].map((option) => (
                                      <label
                                        key={option.value}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          fontSize: "14px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          value={option.value}
                                          checked={
                                            selectedOption === option.value
                                          }
                                          onChange={handleOptionChange}
                                          style={{
                                            width: "20px", // Set size directly
                                            height: "20px",
                                            cursor: "pointer",
                                            accentColor: "#007bff", // Optional: Bootstrap blue
                                          }}
                                        />
                                        {option.label}
                                      </label>
                                    ))}
                                  </div> */}

                                  <button
                                    type="button"
                                    className="btn btn-primary mt-3"
                                    onClick={handleApproveLoanUpdate}
                                  >
                                    Approve
                                  </button>
                                </div>
                              )}
                            </form>
                          </Modal.Body>
                          <Modal.Footer>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={handleCloseLoanUpdate}
                            >
                              Cancel
                            </button>

                            {!showTable && (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                  if (
                                    loanUpdateDetails.loanAmount &&
                                    loanUpdateDetails.interestRate &&
                                    loanUpdateDetails.installment
                                  ) {
                                    handleLoanUpdate(
                                      loanUpdateDetails.loanAmount,
                                      loanUpdateDetails.interestRate,
                                      loanUpdateDetails.installment
                                    );
                                  }
                                }}
                              >
                                Submit
                              </button>
                            )}
                          </Modal.Footer>
                        </Modal>
                        <Epf
                          openModal={openModal}
                          setOpenModal={setOpenModal}
                          appId={
                            data.appClientId
                              ? data.appClientId
                              : data.appclientid
                          }
                        />

                        <div
                          style={{
                            fontFamily: "PostGrotesk",
                            borderRadius: "10px",
                          }}
                        >
                          <div className="row mt-3">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Loan Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Loan Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.loanid}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.enrollmentid}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Sanction Amount
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.sanctionAmount}
                                        <button
                                          className="btn btn-primary"
                                          style={{
                                            marginTop: "1%",
                                            marginLeft: "2%",
                                          }}
                                          onClick={() => handleOpenLoanUpdate()}
                                        >
                                          Change Amount
                                        </button>
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Scheme No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.schemeNo}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Over due
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {eqfexdata?.overdue}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>Score</th>
                                      <th style={{ border: "none" }}>
                                        {eqfexdata?.score}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Live Loan
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {eqfexdata?.liveLoan}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Write of amount
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {eqfexdata?.writeofamount}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        GEO LOCATION
                                      </th>
                                      <th style={{ border: "none" }}>
                                        <button
                                          className="btn btn-primary"
                                          role="tab"
                                          style={{ textDecoration: "none" }}
                                          onClick={groLocation}
                                        >
                                          GEOLOCATION
                                        </button>
                                      </th>
                                    </tr>

                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Product
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.product}
                                      </th>
                                    </tr> */}
                                    {/* <tr>
                                      <th style={{ border: "none" }}>Period</th>
                                      <th style={{ border: "none" }}>
                                        {data?.period}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>EMI</th>
                                      <th style={{ border: "none" }}>
                                        {data?.emi}
                                      </th>
                                    </tr> */}
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Equifax 360
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.score}
                                      </th>
                                    </tr> */}
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Pincode
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.pincode}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>E-Mail</th>
                                      <th style={{ border: "none" }}>
                                        {data.emailid}
                                      </th>
                                    </tr>
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Date Of Exit
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.dateofexit}
                                      </th>
                                    </tr> */}
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Office Pincode
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.officeaddress}
                                      </th>
                                    </tr> */}
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Client Account No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientaccountno}
                                      </th>
                                    </tr> */}
                                  </tbody>
                                </table>
                                <div className="mt-3">
                                  <span className="fw-bold ms-2">
                                    Borrower KYC Address :-
                                  </span>
                                  <br />
                                  <div
                                    className="ms-3"
                                    style={{ fontSize: "18px" }}
                                  >
                                    <span>
                                      {data.clienthouseno && (
                                        <span>{data.clienthouseno}, </span>
                                      )}
                                      {data.clientstreet && (
                                        <span>{data.clientstreet}, </span>
                                      )}
                                      {data.clientlocality && (
                                        <span>{data.clientlocality}, </span>
                                      )}
                                      {data.clientlandmark && (
                                        <span>{data.clientlandmark}, </span>
                                      )}
                                      {data.clienttown && (
                                        <span>{data.clienttown}, </span>
                                      )}
                                      {data.clientpostoffice && (
                                        <span>{data.clientpostoffice}, </span>
                                      )}
                                      {data.clientsubdistrict && (
                                        <span>{data.clientsubdistrict}, </span>
                                      )}
                                      {data.clientdistrict && (
                                        <span>{data.clientdistrict}, </span>
                                      )}
                                      {data.clientstate && (
                                        <span>{data.clientstate}, </span>
                                      )}
                                      {data.clientpincode && (
                                        <span>{data.clientpincode}</span>
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="mt-3 d-flex mb-3">
                                  <span className="fw-bold ms-2">
                                    EPF Verify
                                  </span>
                                  <br />
                                  <div
                                    className="ms-3"
                                    style={{ fontSize: "18px" }}
                                  >
                                    <button
                                      className="btn btn-success"
                                      style={{ width: "100px" }}
                                      onClick={() => setOpenModal(true)}
                                    >
                                      Verify
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Borrower Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        App Client Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.appClientId
                                          ? data.appClientId
                                          : data.appclientid}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>Name</th>
                                      <th style={{ border: "none" }}>
                                        {data.name || data.clientname}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>Gender</th>
                                      <th style={{ border: "none" }}>
                                        {data.gender === "M"
                                          ? "Male"
                                          : data.gender === "F"
                                          ? "Female"
                                          : ""}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>C/O</th>
                                      <th style={{ border: "none" }}>
                                        {data.careOf}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Relation
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.relation === "M"
                                          ? "Mother"
                                          : data.relation === "F"
                                          ? "Father"
                                          : data.relation === "H"
                                          ? "Husband"
                                          : data.relation === "W"
                                          ? "Wife"
                                          : ""}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Date Of Birth
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.dateOfBirth
                                          ? moment(data.dateOfBirth).format(
                                              "DD-MM-YYYY"
                                            )
                                          : ""}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>Mobile</th>
                                      <th style={{ border: "none" }}>
                                        {data.mobile}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        KYC Aadhar Card
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.kycAadhaarNumber ||
                                          data.kycNumber}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Employee Type
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.employeeType === 1
                                          ? "Salaried Employee"
                                          : data.employeeType === 2
                                          ? "Self Employee"
                                          : ""}
                                      </th>
                                    </tr>
                                    {data.employeeType === 2 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Average Eod Balance
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.averageEodBalance}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 2 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Total No of Credit
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.totalNoOfCreditTransactions}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 2 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Total No of Debit
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.totalNoOfDebitTransactions}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Employee Name
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.employerName}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Date Of Joining
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {moment(data.dateOfJoining).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </th>
                                      </tr>
                                    )}
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Equifax Score Microfinance
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.equifaxScoreMicrofinance}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Equifax Score Retail
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.equifaxScoreRetail}
                                      </th>
                                    </tr> */}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Account Aggregator Name
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.accountAggregatorName}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          First Month Salary
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.firstMonthSalary}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Second Month Salary
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.secondMonthSalary}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Third Month Salary
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.thirdMonthSalary}
                                        </th>
                                      </tr>
                                    )}
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Account No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.accountno}
                                      </th>
                                    </tr>
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Establishment Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.establishmentName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Employer
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfisemployed}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Total Amount
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epftotalamount}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Employees Count
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfemployeescont}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Date Of Joining
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfdateofjoining}
                                      </th>
                                    </tr> */}
                                  </tbody>
                                </table>
                              </div>
                              <div
                                className="mt-2"
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Banking</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        UPI Nach Account No
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {data.clientaccountno || "-"}
                                      </th>
                                    </tr>

                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        AA account No
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {data.accountno || "-"}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div
                                className="mt-2"
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">UPI</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        Nach UPI ID
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {data.upiId || "-"}
                                      </th>
                                    </tr>

                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        QR Code ID
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {pdData?.appUploadUpiId || "-"}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div
                                className="mt-2"
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Name</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        ⁠ ⁠⁠AA Name
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {data.accountAggregatorName || "-"}
                                      </th>
                                    </tr>

                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        ⁠⁠UPI Nach Account Name
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {data.name || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        ⁠⁠QR code name
                                      </th>
                                      <th
                                        style={{
                                          border: "none",
                                          color: "green",
                                        }}
                                      >
                                        {pdData.qrName || "-"}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Current Scheme Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Scheme No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.schemeno}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Loan Amount
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.loanAmount}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Installments
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.installments}
                                      </th>
                                    </tr>
                                    {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Processing Fee (PF)
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.pf}
                                      </th>
                                    </tr> */}
                                    <tr>
                                      <th style={{ border: "none" }}>PF GST</th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.pfGst}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Insurance
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.insurance}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Insurance GST
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.insuranceGst}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        HospiCash
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.hospiCash}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>EMI</th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.emi}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Net Disbursal Amount
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.netDisbAmount}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        IRR (%)
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.irr}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        APR (%)
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {schemeData.apr}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div
                                className="mt-2"
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Nach Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>UPI Id</th>
                                      <th style={{ border: "none" }}>
                                        {data.upiId || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Upload Status
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.nachUploadStatus || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Emandate Bank Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.emandateBankName || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Emandate Client Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.emandateClientName || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>IFSC</th>
                                      <th style={{ border: "none" }}>
                                        {data.accountIfsc || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Customer A/C No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.customerAccountNumber || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        A/C Holder Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.accountHolderName || "-"}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div
                                className="mt-2"
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Bank Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Bank Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.bankname || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>A/C No</th>
                                      <th style={{ border: "none" }}>
                                        {data.clientaccountno || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Bank Branch
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.bankBranch || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        IFSC Code
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.ifscCode || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>Cheque</th>
                                      <th style={{ border: "none" }}>
                                        {data.cheque || "-"}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            {/* <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Reference Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientName || data.clientname}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Account Aggregator Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.accountAggregatorName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Current Organisation Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.currentOrganisationName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Sim Owner Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.simOwnerName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PAN Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.panName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Relation
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefRelation}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefMobile}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendMobileno}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend No Of Years
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendNoOfYears}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div> */}
                          </div>

                          <div className="mt-5 d-flex justify-content-center">
                            <table className="table table-bordered w-100 w-md-75 border">
                              <tbody>
                                {!hide && (
                                  <>
                                    <tr className="border">
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          border: "none",
                                        }}
                                      >
                                        Approval Status
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                        }}
                                      >
                                        <div className="row mt-2">
                                          <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                                            <input
                                              type="radio"
                                              name="shipSpeed"
                                              value="2"
                                              checked={approvalStatus === "2"}
                                              onChange={(e) =>
                                                setApprovalStatus(
                                                  e.target.value
                                                )
                                              }
                                              style={{
                                                height: "18px",
                                                width: "18px",
                                              }}
                                            />
                                            <label className="m-0">
                                              Approve
                                            </label>
                                          </div>
                                          <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center">
                                            <input
                                              type="radio"
                                              name="shipSpeed"
                                              value="3"
                                              checked={approvalStatus === "3"}
                                              onChange={(e) =>
                                                setApprovalStatus(
                                                  e.target.value
                                                )
                                              }
                                              style={{
                                                height: "18px",
                                                width: "18px",
                                              }}
                                            />
                                            <label className="m-0">
                                              Reject
                                            </label>
                                          </div>
                                        </div>
                                        <div className="d-flex align-items-center mt-3 mb-2">
                                          <input
                                            type="radio"
                                            onClick={() =>
                                              setShowUploadModal(true)
                                            }
                                            style={{
                                              height: "18px",
                                              width: "18px",
                                            }}
                                          />
                                          <label className="m-0">
                                            Employer contact Details Upload
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr className="border">
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          border: "none",
                                        }}
                                      >
                                        Remark:
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                        }}
                                      >
                                        <textarea
                                          value={remark}
                                          onChange={(e) =>
                                            setRemark(e.target.value)
                                          }
                                          style={{ width: "80%" }}
                                        />
                                      </td>
                                    </tr>
                                    <tr className="border">
                                      <td
                                        style={{
                                          fontWeight: "bold",
                                          border: "none",
                                        }}
                                      >
                                        Approval
                                      </td>
                                      <td
                                        style={{
                                          border: "none",
                                          textAlign: "center",
                                        }}
                                      >
                                        <button
                                          className="btn btn-success"
                                          style={{ background: "#66a725" }}
                                          onClick={() =>
                                            setShowPasswordModal(true)
                                          }
                                        >
                                          Submit
                                        </button>
                                      </td>
                                    </tr>
                                  </>
                                )}

                                <Modal
                                  show={showUploadModal}
                                  onHide={() => setShowUploadModal(false)}
                                  centered
                                  style={{ background: "#ffffffd1" }}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>
                                      Employer contact Details Upload
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <input
                                      type="file"
                                      onChange={handleDetailsChange}
                                      style={{
                                        width: "100%",
                                        padding: "10px",
                                        boxSizing: "border-box",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                    />
                                    <div className="d-flex mt-3 justify-content-end">
                                      <button
                                        className="btn btn-secondary"
                                        style={{ width: "100px" }}
                                        onClick={() =>
                                          setShowUploadModal(false)
                                        }
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-success ml-2"
                                        style={{
                                          width: "100px",
                                          background: "#66a725",
                                        }}
                                        onClick={employerUploadContact}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                                <Modal
                                  show={showPasswordModal}
                                  onHide={() => setShowPasswordModal(false)}
                                  centered
                                  style={{ background: "#ffffffd1" }}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>Enter Password</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <input
                                      type="password"
                                      value={password}
                                      onChange={handlePasswordChange}
                                      style={{
                                        width: "100%",
                                        padding: "10px",
                                        boxSizing: "border-box",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                    />
                                    <div className="d-flex mt-3 justify-content-end">
                                      <button
                                        className="btn btn-secondary"
                                        style={{ width: "100px" }}
                                        onClick={() =>
                                          setShowPasswordModal(false)
                                        }
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-success ml-2"
                                        style={{
                                          width: "100px",
                                          background: "#66a725",
                                        }}
                                        onClick={handleSubmit}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                                <Modal
                                  show={showApproveModal}
                                  onHide={() => setShowApproveModal(false)}
                                  centered
                                  style={{ background: "#ffffffd1" }}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title></Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body style={{ height: "120px" }}>
                                    <div className="d-flex mt-3 justify-content-center">
                                      <button
                                        className="btn btn-secondary"
                                        style={{
                                          background: "#66a725",
                                        }}
                                        onClick={() => handleApprove("new")}
                                      >
                                        New
                                      </button>
                                      <button
                                        className="btn btn-success ml-2"
                                        style={{
                                          background: "#66a725",
                                        }}
                                        onClick={() => handleApprove("ignore")}
                                      >
                                        Ignore
                                      </button>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                                <tr
                                  className="border"
                                  style={{ background: "#66a725" }}
                                >
                                  <td
                                    style={{
                                      fontWeight: "bold",
                                      border: "none",
                                    }}
                                  >
                                    Approval Status
                                  </td>
                                  <td
                                    style={{
                                      border: "none",
                                      textAlign: "center",
                                    }}
                                  >
                                    {data.cibli_status === 0 && (
                                      <span>
                                        <span style={{ fontWeight: "bold" }}>
                                          Equifax Rejected
                                        </span>{" "}
                                        on {data.cibil_date}
                                      </span>
                                    )}
                                    <span>
                                      <span style={{ fontWeight: "bold" }}>
                                        Further Action
                                      </span>{" "}
                                      by
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* {(data.grtApprovalStatus === 0 ||
        data.cibli_status === 0 ||
        data.creditstatus === 2 ||
        data.creditstatus === 3 ||
        data.isDeleted === 1) && (
        <Table bordered responsive style={{ width: "70%", marginLeft: "15%" }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold", borderRight: "none", borderTop: "none" }}>
                Remark:
              </td>
              <td style={{ borderLeft: "none", borderTop: "none", width: "60%" }}>
                {remark}
              </td>
            </tr>
            {[3, 4].includes(data.creditstatus) && (
              <tr>
                <td style={{ fontWeight: "bold", borderRight: "none" }}>
                  Reason
                </td>
                <td style={{ borderLeft: "none", textAlign: "center" }}>
                  {data.otherReason == null ? data.reason : data.otherReason}
                </td>
              </tr>
            )}
            <tr style={{ backgroundColor: "#A8BB21" }}>
              <td style={{ fontWeight: "bold", borderRight: "none" }}>
                Approval Status
              </td>
              <td style={{ borderLeft: "none", textAlign: "center" }}>
                {data.creditstatus === 2 && (
                  <span>
                    <span style={{ fontWeight: "bold" }}>TVR Approved</span> by {data.approvedbyname} ({data.approvedby}) on {data.sanctionletterdate}
                  </span>
                )}
                {data.creditstatus === 3 && (
                  <span>
                    <span style={{ fontWeight: "bold" }}>TVR Rejected</span> by {data.approvedbyname} ({data.approvedby}) on {data.sanctionletterdate} Reason- {data.reason}
                  </span>
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "tab2" ? "show active" : ""
              }`}
              id="tab2"
              role="tabpanel"
              aria-labelledby="tab2-tab"
            >
              <div className="pt-3">
                {
                  <div className="card">
                    <div className="p-3">
                      <div className="d-flex">
                        <DownloadTableExcel
                          filename="NEFT Data"
                          sheet="users"
                          currentTableRef={InstantDisbursed.current}
                        >
                          <button
                            className="btn btn-success border"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            {" "}
                            Download{" "}
                          </button>
                        </DownloadTableExcel>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          {/* TVR Approve */}
                          <table
                            className="table table-striped"
                            ref={InstantDisbursed}
                          >
                            <thead>
                              <tr>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Sr. No
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  App Client Id
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Client Name
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Mobile No
                                </th>
                                {/* <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Loan Type
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Scheme No.
                                    </th>
                                    <th
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      Sanction Amount
                                    </th> */}
                                {/* <th
                                    className="text-nowrap"
                                    style={{ textAlign: "center" }}
                                  >
                                    Branch Name
                                  </th> */}

                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  Approve Date
                                </th>
                                <th
                                  className="text-nowrap"
                                  style={{ textAlign: "center" }}
                                >
                                  CA Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {instantDisburse && instantDisburse.length > 0 ? (
                                instantDisburse.map((item, i) => (
                                  <tr key={i}>
                                    {console.log("item::: ", item)}
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {i + 1}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{
                                        textAlign: "center",

                                        cursor: "pointer",
                                      }}
                                      // onClick={() => {
                                      //   if (item.AppClientId) {
                                      //     setAppClientId(item.AppClientId);
                                      //     setShowSearch(true);
                                      //   }
                                      // }}
                                    >
                                      {item.AppClientId}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.BorrName}
                                    </td>
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      {item.BorrContactNo}
                                    </td>
                                    {/* <td className="text-nowrap">
                                            {item.loanType}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.schemeNo}
                                          </td>
                                          <td
                                            className="text-nowrap"
                                            style={{ textAlign: "center" }}
                                          >
                                            {item.sanctionAmount}
                                          </td> */}
                                    {/* <td
                                        className="text-nowrap"
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.branchName}
                                      </td> */}
                                    <td
                                      className="text-nowrap"
                                      style={{ textAlign: "center" }}
                                    >
                                      {item.Approveddate}
                                    </td>
                                    <td>
                                      <button
                                        className="btn btn-success"
                                        onClick={() => {
                                          setShow(true);
                                          // getAddharMessage(
                                          //   item?.borrcontactNo
                                          // );
                                          setLoanId(item?.LoanId);
                                          setLoanId(item?.AppClientId);
                                          // getPdDetails(item?.AppClientId);
                                          getAllDoc(item?.AppClientId);
                                          getClientDetailsMagic(
                                            item?.AppClientId
                                          );
                                        }}
                                      >
                                        {item.CreditStatus == 2 && "View"}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="9"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {/* {instantDisburse && instantDisburse.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={instantDisburse.length}
                      />
                    )} */}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "tab3" ? "show active" : ""
              }`}
              id="tab3"
              role="tabpanel"
              aria-labelledby="tab3-tab"
            >
              <div className="pt-3">
                <div className="card">
                  <div className="p-3">
                    <div className="d-flex ">
                      <DownloadTableExcel
                        filename="NEFT Data"
                        sheet="users"
                        currentTableRef={NEFTData.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive mt-3">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sr. No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Client Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Mobile No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Done By Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Done By Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Entry Date
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Status Desc
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {neftSuccessData
                              ?.slice(pagination.start, pagination.end)
                              ?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1 + pagination.start}</td>

                                  <td className="text-nowrap">{item.loanid}</td>
                                  <td className="text-nowrap">
                                    {item.clientname}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.clientmobileno}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.doneById}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.doneByName}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.entryDate}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.statusDesc}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {neftSuccessData && neftSuccessData.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={neftSuccessData.length}
                      />
                    )}
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={NEFTData}
                    >
                      <thead>
                        <tr>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sr. No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Loan Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Client Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Mobile No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Done By Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Done By Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Entry Date
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Status Desc
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {neftSuccessData?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>

                            <td className="text-nowrap">{item.loanid}</td>
                            <td className="text-nowrap">{item.clientname}</td>
                            <td className="text-nowrap">
                              {item.clientmobileno}
                            </td>
                            <td className="text-nowrap">{item.doneById}</td>
                            <td className="text-nowrap">{item.doneByName}</td>
                            <td className="text-nowrap">{item.entryDate}</td>
                            <td className="text-nowrap">{item.statusDesc}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "tab4" ? "show active" : ""
              }`}
              id="tab4"
              role="tabpanel"
              aria-labelledby="tab4-tab"
            >
              <div className="pt-3">
                <div className="card">
                  <div className="p-3">
                    <div className="d-flex">
                      <DownloadTableExcel
                        filename="NEFT Rejected Data"
                        sheet="users"
                        currentTableRef={NEFTRejected.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive mt-3">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sr. No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Client Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Mobile No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Done By Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Done By Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Entry Date
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Status Desc
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {neftRejectedData
                              ?.slice(pagination.start, pagination.end)
                              ?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>

                                  <td className="text-nowrap">{item.loanid}</td>
                                  <td className="text-nowrap">
                                    {item.clientname}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.clientmobileno}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.doneById}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.doneByName}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.entryDate}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.statusDesc}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {neftRejectedData && neftRejectedData.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={neftRejectedData.length}
                      />
                    )}
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={NEFTRejected}
                    >
                      <thead>
                        <tr>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sr. No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Loan Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Client Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Mobile No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Done By Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Done By Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Entry Date
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Status Desc
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {neftRejectedData?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>

                            <td className="text-nowrap">{item.loanid}</td>
                            <td className="text-nowrap">{item.clientname}</td>
                            <td className="text-nowrap">
                              {item.clientmobileno}
                            </td>
                            <td className="text-nowrap">{item.doneById}</td>
                            <td className="text-nowrap">{item.doneByName}</td>
                            <td className="text-nowrap">{item.entryDate}</td>
                            <td className="text-nowrap">{item.statusDesc}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "tab5" ? "show active" : ""
              }`}
              id="tab5"
              role="tabpanel"
              aria-labelledby="tab5-tab"
            >
              <div className="pt-3">
                <div className="card">
                  <div className="p-3">
                    <div className="d-flex ">
                      <DownloadTableExcel
                        filename="TVR Rejected"
                        sheet="users"
                        currentTableRef={TVRRejected.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive mt-3">
                        <table className="table table-striped ">
                          <thead>
                            <tr>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sr. No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                App Client Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Client Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Mobile No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Type
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Scheme No.
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sanction Amount
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Branch Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Cluster
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Rejected Date
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {tvrRejected
                              ?.slice(pagination.start, pagination.end)
                              ?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1 + pagination.start}</td>

                                  <td className="text-nowrap">
                                    {item.appClientId}
                                  </td>
                                  <td className="text-nowrap">{item.loanid}</td>
                                  <td className="text-nowrap">
                                    {item.clientName}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.clientmobileno}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.loanType}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.schemeNo}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.sanctionAmount}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.branchname}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.cluster}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.verificationDate}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {tvrRejected && tvrRejected.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={tvrRejected.length}
                      />
                    )}

                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={TVRRejected}
                    >
                      <thead>
                        <tr>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sr. No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            App Client Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Loan Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Client Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Mobile No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Loan Type
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Scheme No.
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sanction Amount
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Branch Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Cluster
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Rejected Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {tvrRejected?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>

                            <td className="text-nowrap">{item.appClientId}</td>
                            <td className="text-nowrap">{item.loanid}</td>
                            <td className="text-nowrap">{item.clientName}</td>
                            <td className="text-nowrap">
                              {item.clientmobileno}
                            </td>
                            <td className="text-nowrap">{item.loanType}</td>
                            <td className="text-nowrap">{item.schemeNo}</td>
                            <td className="text-nowrap">
                              {item.sanctionAmount}
                            </td>
                            <td className="text-nowrap">{item.branchname}</td>
                            <td className="text-nowrap">{item.cluster}</td>
                            <td className="text-nowrap">
                              {item.verificationDate}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${
                activeTab === "tab6" ? "show active" : ""
              }`}
              id="tab6"
              role="tabpanel"
              aria-labelledby="tab6-tab"
            >
              <div className="pt-3">
                <div className="card">
                  <div className="p-3">
                    <div className="d-flex">
                      <DownloadTableExcel
                        filename="ReHit Penny Drop"
                        sheet="users"
                        currentTableRef={ReHitDrop.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive mt-3">
                        <table className="table table-striped ">
                          <thead>
                            <tr>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sr. No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                App Client Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Loan Id
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Client Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Mobile No
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Sanction Amount
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Branch Name
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                IFSC Code
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Bank Branch
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Entry Date
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Status
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Approve
                              </th>
                              <th
                                className="text-nowrap"
                                style={{ textAlign: "center" }}
                              >
                                Reject
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {reHitPennyDrop
                              ?.slice(pagination.start, pagination.end)
                              ?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1 + pagination.start}</td>

                                  <td className="text-nowrap text-center">
                                    {item.appclientid}
                                  </td>
                                  <td className="text-nowrap text-center">
                                    {item.loanid}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.clientname}
                                  </td>
                                  <td className="text-nowrap  text-center">
                                    {item.clientmobileno}
                                  </td>
                                  <td className="text-nowrap text-center">
                                    {item.sanctionAmount}
                                  </td>
                                  <td className="text-nowrap">
                                    {item.branchName}
                                  </td>
                                  <td className="text-nowrap text-center">
                                    {item.clientBankIfsc}
                                  </td>
                                  <td className="text-nowrap text-center">
                                    {item.clientAccountNo}
                                  </td>
                                  <td className="text-nowrap text-center">
                                    {item.entrydate}
                                  </td>
                                  <td className="text-nowrap">{item.status}</td>
                                  <td className="text-nowrap">
                                    <button
                                      className="btn btn-success"
                                      onClick={() =>
                                        reHitPennyDropApprove(item.loanid)
                                      }
                                    >
                                      {isLoader ? (
                                        <div
                                          className="spinner-border text-success"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        "Approve"
                                      )}
                                    </button>
                                  </td>
                                  <td className="text-nowrap">
                                    <button
                                      className="btn btn-success"
                                      onClick={() =>
                                        reHitPennyDropReject(item.loanid)
                                      }
                                    >
                                      {isLoader ? (
                                        <div
                                          className="spinner-border text-success"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      ) : (
                                        "Reject"
                                      )}
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {reHitPennyDrop && reHitPennyDrop.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={reHitPennyDrop.length}
                      />
                    )}
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={ReHitDrop}
                    >
                      <thead>
                        <tr>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sr. No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            App Client Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Loan Id
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Client Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Mobile No
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Sanction Amount
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Branch Name
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            IFSC Code
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Bank Branch
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Entry Date
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Status
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Approve
                          </th>
                          <th
                            className="text-nowrap"
                            style={{ textAlign: "center" }}
                          >
                            Reject
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reHitPennyDrop?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>

                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.appclientid}
                            </td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.loanid}
                            </td>
                            <td className="text-nowrap">{item.clientname}</td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.clientmobileno}
                            </td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.sanctionAmount}
                            </td>
                            <td className="text-nowrap">{item.branchName}</td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.clientBankIfsc}
                            </td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.clientAccountNo}
                            </td>
                            <td
                              className="text-nowrap"
                              style={{ textAlign: "center" }}
                            >
                              {item.entrydate}
                            </td>
                            <td className="text-nowrap">{item.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditAppraisalForMagic;
